export default class ProductList {

  constructor($el) {
    if (window.innerWidth > 768) return;

    this.root = $el;
    this.list = $el.find('.js-product-list_list');
    this.seeMore = $el.find('.js-product-list_see-more');

    this.lastItemVisible = $el.find('.is-last-visible');
    this.lastItemTop = this.getLastItemPos();
    this.listTop = this.getItemPos(this.list);

    setTimeout(() => {
      this.listOriginalHeight = this.list.outerHeight();
      this.lastItemVisible.addClass('is-active');
      this.listHiddenHeight = this.list.outerHeight();

      this.prepareTransition();
    }, 100);

    this.seeMore.click(e => {
      e.preventDefault();

      requestAnimationFrame(() => {
        this.list.css(
          'height',
          this.listOriginalHeight
        );

        this.lastItemVisible.removeClass('is-active');

        setTimeout(() => {
          this.lastItemVisible.addClass('is-fade-in');
          this.seeMore.addClass('is-fade-out');
        });
      });
    });
  }

  prepareTransition() {
    this.list.css('height', this.listHiddenHeight);
  }

  getLastItemPos() {
    return this.root.find('li').last().offsetTop;
  }

  getItemPos($item) {
    return $item.offsetTop;
  }
}


// WEBPACK FOOTER //
// ./src/components/product-list/product-list.js